import $ from "jquery";

// Legacy admin extensions (including layout_design.js) expect the jQuery
// instance used by EC-CUBE to be available on the window object. Webpack keeps
// imported modules scoped by default, so expose the single shared instance
// explicitly before any extension script is loaded.
window.jQuery = $;
window.$ = $;

import "jquery-migrate";
/* 警告を無効にする */
$.migrateMute = true;

import "jquery-ui/ui/widget"
import "jquery-ui/ui/data"
import "jquery-ui/ui/scroll-parent"
import "jquery-ui/ui/position"
import "jquery-ui/ui/widgets/mouse"
import "jquery-ui/ui/widgets/sortable"
import "jquery-ui/themes/base/core.css";
import "jquery-ui/themes/base/theme.css";
import "jquery-ui/themes/base/sortable.css";

/*
 * This file is part of EC-CUBE
 *
 * Copyright(c) EC-CUBE CO.,LTD. All Rights Reserved.
 *
 * http://www.ec-cube.co.jp/
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 59 Temple Place - Suite 330, Boston, MA  02111-1307, USA.
 */

(function (window, undefined) {
  // 名前空間の重複を防ぐ
  if (window.eccube === undefined) {
    window.eccube = {};
  }

  const { eccube } = window;

  eccube.isReauthenticationResponse = function (response) {
    if (!response || Number(response.status) !== 401) {
      return false;
    }
    if (response.headers && typeof response.headers.get === "function") {
      return response.headers.get("X-GBank-Reauthentication") === "required";
    }
    return typeof response.getResponseHeader === "function" &&
      response.getResponseHeader("X-GBank-Reauthentication") === "required";
  };

  eccube.handleReauthenticationResponse = function (response) {
    if (!eccube.isReauthenticationResponse(response)) {
      return false;
    }
    if (window.reauthenticationRedirected) {
      return true;
    }
    const loginUrl = response.headers && typeof response.headers.get === "function" ?
      response.headers.get("X-GBank-Reauthentication-Url") :
      response.getResponseHeader("X-GBank-Reauthentication-Url");
    if (typeof loginUrl !== "string" || loginUrl === "") {
      return true;
    }
    let target;
    try {
      target = new URL(loginUrl, window.location.href);
    } catch (error) {
      return true;
    }
    if (target.origin !== window.location.origin) {
      return true;
    }
    window.reauthenticationRedirected = true;
    window.top.location.replace(target.href);
    return true;
  };

  const isSameOriginRequest = (request) => {
    try {
      const requestUrl = request instanceof Request ? request.url : request;
      return new URL(requestUrl, window.location.href).origin === window.location.origin;
    } catch (error) {
      return false;
    }
  };

  if (typeof window.fetch === "function" && !window.eccubeFetchInterceptorInstalled) {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const sameOrigin = isSameOriginRequest(args[0]);
      return originalFetch.apply(this, args).then((response) => {
        if (sameOrigin) {
          eccube.handleReauthenticationResponse(response);
        }
        return response;
      });
    };
    window.eccubeFetchInterceptorInstalled = true;
  }

  if (!window.eccubeAjaxInterceptorInstalled) {
    $.ajaxPrefilter((options, _originalOptions, jqXHR) => {
      if (isSameOriginRequest(options.url)) {
        jqXHR.always(() => {
          eccube.handleReauthenticationResponse(jqXHR);
        });
      }
    });
    window.eccubeAjaxInterceptorInstalled = true;
  }

  eccube.defaults = {
    formId: "form1",
  };

  eccube.fnFormModeSubmit = function (form, mode, keyname, keyid) {
    switch (mode) {
      case "delete":
        if (
          !window.confirm(
            "一度削除したデータは、元に戻せません。\n削除しても宜しいですか？"
          )
        ) {
          return;
        }
        break;
      case "confirm":
        if (!window.confirm("登録しても宜しいですか")) {
          return;
        }
        break;
      case "regist":
        if (!window.confirm("登録しても宜しいですか")) {
          return;
        }
        break;
      default:
        break;
    }
    const values = { mode };
    if (
      keyname !== undefined &&
      keyname !== "" &&
      keyid !== undefined &&
      keyid !== ""
    ) {
      values[keyname] = keyid;
    }
    eccube.submitForm(values, form);
  };

  eccube.setValueAndSubmit = function (form, key, val, msg) {
    let ret;
    if (msg !== undefined) {
      ret = window.confirm(msg);
    } else {
      ret = true;
    }
    if (ret) {
      const values = {};
      values[key] = val;
      eccube.submitForm(values, form);
    }
    return false;
  };

  eccube.setValue = function (key, val, form) {
    const formElement = eccube.getFormElement(form);
    formElement.find(`*[name=${key}]`).val(val);
  };

  // ページナビで使用する。
  eccube.movePage = function (pageno, mode, form) {
    const values = { pageno };
    if (mode !== undefined) {
      values.mode = mode;
    }
    eccube.submitForm(values, form);
  };

  /**
   * フォームを送信する.
   *
   * @param values
   * @param form
   */
  eccube.submitForm = function (values, form) {
    const formElement = eccube.getFormElement(form);
    if (values !== undefined && typeof values === "object") {
      $.each(values, (index, value) => {
        eccube.setValue(index, value, formElement);
      });
    }
    formElement.submit();
  };

  /**
   * フォームを特定してエレメントを返す.
   *
   * @param form
   * @returns {*}
   */
  eccube.getFormElement = function (form) {
    let formElement;
    if (form !== undefined && typeof form === "string" && form !== "") {
      formElement = $(`form#${form}`);
    } else if (form !== undefined && typeof form === "object") {
      formElement = form;
    } else {
      formElement = $(`form#${eccube.defaults.formId}`);
    }
    return formElement;
  };

  // 文字数をカウントする。
  // 引数1：フォーム名称
  // 引数2：文字数カウント対象
  // 引数3：カウント結果格納対象
  eccube.countChars = function (form, sch, cnt) {
    const formElement = $(`form#${form}`);
    formElement
      .find(`input[name=${cnt}]`)
      .val(formElement.find(`*[name=${sch}]`).val().length);
  };

})(window);
